import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import ResponsiveNavbar, { DESKTOP_DRAWER_WIDTH, MOBILE_BOTTOM_NAV_HEIGHT } from "app/components/layout/ResponsiveNavbar";
import Footer from "app/components/layout/Footer";
import OfflineBanner from "shared/ui/OfflineBanner";
import { Toaster } from "sonner";
import { useBreakpoint } from "shared/hooks/useBreakpoint";

const MOBILE_CONTENT_BOTTOM_OFFSET = `calc(${MOBILE_BOTTOM_NAV_HEIGHT}px + env(safe-area-inset-bottom, 0px))`;

/**
 * Public shell aligned with MainLayout: same app bar height, brand row (logo + title),
 * horizontal padding rhythm, and global toasts (Nielsen: consistency, visibility of status).
 */
export default function PublicLayout() {
    const { isDesktop } = useBreakpoint();
    const marginLeft = isDesktop ? DESKTOP_DRAWER_WIDTH : 0;

    return (
        <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>

            <OfflineBanner />

            {/* Navigation shell (permanent Drawer on desktop, AppBar+Drawer on mobile) */}
            <ResponsiveNavbar />
            
            {/* Content container */}
            <Box
                component="main"
                id="main-content"
                sx={{
                    flexGrow: 1,
                    minHeight: "100vh",
                    ml: `${marginLeft}px`,
                    pt: { xs: 0, md: 2 },
                    px: { xs: 0, sm: 3, md: 4 },
                    pb: { xs: MOBILE_CONTENT_BOTTOM_OFFSET, md: 8 },
                }}
            >
                <Outlet />
                <Footer />
            </Box>

            <Toaster richColors position="top-right" duration={3000} />
        </Box>
    );
}
